import { configureStore } from "@reduxjs/toolkit";
import reducer from './reducer';

// ==============================|| REDUX - MAIN STORE ||============================== //

export const store = configureStore({reducer: reducer})
